import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const toastId = {
  connectionOnline: 'CONNECTION_ONLINE',
  connectionOffline: 'CONNNECTION_OFFLINE',
};

const useCheckConnection = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const handleOnline = () => {
      toast.dismiss(toastId.connectionOffline);
      toast.success(`${t('connection.online')}`, {
        toastId: toastId.connectionOnline,
      });
    };
    const handleOffline = () => {
      toast.dismiss(toastId.connectionOnline);
      toast.error(`${t('connection.offline')}`, {
        toastId: toastId.connectionOffline,
        closeButton: () => (
          <button
            className="text-toast-error-light text-xs mr-4 flex-none"
            onClick={() => window.location.reload()}
          >
            {t('tryAgain')}
          </button>
        ),
      });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [t]);
};

export default useCheckConnection;
